import React from "react";
import { MenuItem, Icon } from "@material-ui/core";

import { FlexLayout } from "js/Components/FlexLayout";
import { Popup, PopupContent } from "js/Components/Popup";
import { ContextSources, ContextSourceType } from "common/aiConstants";
import { getStaticUrl } from "js/config";

import { PopupContainerStyles } from "./PaneComponents";

export default function ContextSourceTypesPopup(props: { onContextSourceTypeChange: (contextSource: ContextSourceType) => void }) {
    const { onContextSourceTypeChange } = props;

    return (
        <FlexLayout width={228} height={38}>
            <Popup
                label="Add Context"
                contained showArrow disableHoverState
                overrideContainerStyles={PopupContainerStyles}
            >
                <PopupContent>
                    {closePopup => (
                        <PopupContent>
                            {Object.entries(ContextSources).map(([type, { icon, label }]) => (
                                <MenuItem key={type} value={type} onClick={() => {
                                    onContextSourceTypeChange(type as ContextSourceType);
                                    closePopup();
                                }}>
                                    {icon.startsWith("/images/") ? (
                                        <img src={getStaticUrl(icon)} width={24} height={24} />
                                    ) : (
                                        <Icon style={{ color: "#666", fontSize: "24px" }}>{icon}</Icon>
                                    )}
                                    &nbsp; {label}
                                </MenuItem>
                            ))}
                        </PopupContent>
                    )}
                </PopupContent>
            </Popup>
        </FlexLayout>
    );
}